import React from 'react';
import PropTypes from 'prop-types';

import { getTranslation } from 'common/react/utils/translations';
import { TBCRoundTooltip } from './TBCRoundTooltip';

export const FixturesDateHeader = ({ dateKey, round, isTbc = false }) => {
    if (dateKey.startsWith('TBC_')) {
        const parts = dateKey.split('_');
        // the dataKey has a structure of TBC_CD_R202601424_20260820
        const roundId = parts[2];
        const date = parts[3];

        return (
            <div className="fixtures__tbc-date-wrapper">
                <div>
                    <h2 className="fixtures__date-header">
                        {getTranslation('label.fixtures.tbcRoundStartDate')}{' '}
                        {moment(date, 'YYYYMMDD').format('dddd, D MMMM YYYY')}
                    </h2>
                    {!isTbc && (
                        <h3 className="fixtures__date-header-subtitle">
                            {round.name}
                        </h3>
                    )}
                </div>
                <TBCRoundTooltip roundId={roundId} />
            </div>
        );
    }

    const label =
        dateKey === 'TBCPC'
            ? getTranslation('label.fixtures.tbc-postponed-cancelled')
            : moment(dateKey, 'YYYYMMDD')
                  // We don't need to adjust timezone here as it was already adjusted when grouping
                  .format('dddd MMMM D');

    return <h2 className="fixtures__date-header">{label}</h2>;
};

FixturesDateHeader.propTypes = {
    dateKey: PropTypes.string.isRequired,
    round: PropTypes.object,
    isTbc: PropTypes.bool
};
